module.exports = __webpack_public_path__ + "img/ethereum-1.4153ef80.svg";